<template>
  <div>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="shown"
      headerClasses="justify-content-center"
      class="modal-options view-order-details-modal"
      v-if="order != null"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <div slot="header" class="header-location-details">
        <h4 class="title title-up" :style="{ color: myTheme.modalTextColor }">
          {{ $t('text.ordered_menu') }}
        </h4>
        <div class="grid">
          <div class="location-logo">
            <el-image v-if="selectedLocation" :src="selectedLocation.logo">
              <div slot="error" class="image-slot">
                <img class="photo" src="img/logo-error-200.png" />
              </div>
            </el-image>
          </div>
          <div class="location-name">{{ selectedLocation ? selectedLocation.name : "-" }}</div>
          <div class="location-address">
            <i class="k-icon-location-1"></i>
            {{ selectedLocation ? getHelpers.generateFromatedAddress(selectedLocation.address): "-" }}
          </div>
        </div>
      </div>
      <cards
        class="menu-card"
        v-for="(item, index) in order.orderItems"
        :key="index"
      >
        <div class="wrapper-menu-Item" v-if="item.menuItem">
          <div class="box favorite">
            <i
              class="new-ui-icons"
              :class="{
                'k-icon-tab-favourites fav': order.is_favourite,
                'k-icon-heart-line': !order.is_favourite,
              }"
            ></i>
          </div>
          <div class="box details">
            <p class="title" :style="{ color: myTheme.primaryTextColor }">
              {{ item.menuItem.name }}
            </p>

            <p
              class="option-details"
              v-for="(option, index) in item.options"
              :key="index"
            >
              + {{ `${option.name} => ${option.values[0].name}` }}
            </p>
            <div
              class="d-inline dietry-requirements"
              v-for="(dieatry, index) in getHelpers.getMenuItemDieatriesIcons(
                item.menuItem
              )"
              :key="index"
            >
              <i
                class="new-ui-icons mr-1"
                :class="dieatry.icon"
                :title="dieatry.name"
              ></i>
            </div>
          </div>
          <div class="box price text-center my-auto">
            {{ item.price | currency(currentCurrency) }}
          </div>
          <div class="box counter text-center my-auto">
            <div class="btn-group-vertical add">{{ item.quantity }}</div>
          </div>
        </div>
      </cards>

      <template slot="footer">
        <n-button
          type="primary"
          :style="myTheme.customizeButton"
          round
          block
          @click.native="reOrder()"
        >{{ $t('button.order_again') }} <i v-if="isLoading" class="k-icon-spin4"></i>
        </n-button>
      </template>
    </modal>
    <re-order-confirmation
      v-if="order"
      ref="reOrderConfirmation"
      :ItemsNotAvailable="ItemsNotAvailable"
      :ItemsWithDiffPrice="ItemsWithDiffPrice"
      :ItemsNotAvailableByType="ItemsNotAvailableByType"
      :ItemOptionsValuesAvailibility="ItemOptionsValuesAvailibility"
      :ItemsNotAvailableForToday="ItemsNotAvailableForToday"
      :ItemsNotAvailableByTime="ItemsNotAvailableByTime"
      :orderType="order.order_type"
    ></re-order-confirmation>
  </div>
</template>
<script>
import { Button, Cards, Modal } from "@/components";
import { helpers, cartManager, enumHelper } from "@/utilities";
import ReOrderConfirmation from "@/layout/ReOrderConfirmation";
import { mapActions } from "vuex";
import router from "@/router";
export default {
  name: "view-order-details-modal",
  components: {
    [Button.name]: Button,
    Cards,
    Modal,
    ReOrderConfirmation,
  },
  props: {
    order: Object,
  },
  data() {
    return {
      shown: false,
      showOderTypeModal: false,
      getHelpers: helpers,
      cart: null,
      isLoading: false,
      orderCart: null,
      ItemsNotAvailable: [],
      ItemsWithDiffPrice: [],
      ItemsNotAvailableByType: [],
      ItemOptionsValuesAvailibility: [],
      ItemsNotAvailableForToday: [],
      ItemsNotAvailableByTime: [],
      orderLocation: null,
      locationStatus: null,
    };
  },
  methods: {
    ...mapActions(["fetchLocationsByPostCode", "fetchTheme"]),
    openModal() {
      this.shown = true;
    },
    closeModal() {
      this.shown = false;
    },
    reOrder() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.ItemsNotAvailable = [];
      this.ItemsWithDiffPrice = [];
      this.ItemsNotAvailableByType = [];
      this.ItemOptionsValuesAvailibility = [];
      this.ItemsNotAvailableForToday = [];
      this.ItemsNotAvailableByTime = [];

      this.orderLocation = this.order.location;
      this.checkTheLocationAvailibility().then((response) => {
        if (response.status) {
          this.checkTheAvailibilityToMakeOrder().then((continueOrdering) => {
            
            //=== if the user refuse to continue, close the Modal and exit
            if (!continueOrdering) {
              this.closeModal();
              this.isLoading = false;
              return;
            }

            //**** cleare the cart */
            this.reOrderRequest(this.order.id)
              .then((response) => {
                this.orderCart = response.data;
                this.checkTheOrderBeforeOrdering(response.data).then(
                  (result) => {
                    //---- show an popup with the order changes
                    if (result) {
                      this.closeModal();
                      this.$refs.reOrderConfirmation.openModal();
                    } else {
                      //---- continue with the re-order : fill the cart with the correct data
                      this.continueReOrdering();
                    }

                    this.isLoading = false;
                  }
                );
              })
              .catch((e) => {
                this.captureException(e)
                this.isLoading = false;
              });
          });
        } else {
          helpers.showErrorMessageAlert(response.searchErrorText);
        }
      });
    },

    //===== Stap 01 : refresh the location data and check the delivery availability
    checkTheLocationAvailibility() {
      return new Promise((resolve) => {
        if (this.order.order_type != enumHelper.orderType.Delivery) {
          this.fetchTheme().then(() => {
            this.orderLocation = this.selectedLocation;
            resolve({ status: true });
          });
        } else {
          this.fetchLocationsByPostCode(this.order.address.postcode)
            .then((response) => {
              if (response && response.error) {
                //--- display Alert message : Error occured
                resolve({
                  status: false,
                  searchErrorText: this.$t("generic_error.error_occured"),
                });
              } else {
                const locationsInRange = response.data.data.filter(
                  ({ availabe_delivery_postcode }) =>
                    availabe_delivery_postcode === true
                );
                if (locationsInRange.length === 0) {
                  resolve({
                    status: false,
                    searchErrorText: this.$t("message.we_dont_deliver_to_area"),
                  });
                } else {
                  let res = locationsInRange.find(
                    (x) => x.id == this.orderLocation.id
                  );
                  if (res) {
                    this.orderLocation = res;
                    resolve({ status: true });
                  } else {
                    resolve({
                      status: false,
                      searchErrorText: this.$t("message.we_dont_deliver_to_area"),
                    });
                  }
                }
              }
            })
            .catch((e) => {
              this.captureException(e)
              resolve({
                status: false,
                searchErrorText: this.$t("generic_error.error_occured"),
              });
            });
        }
      });
    },

    //===== Step 02 : check the availability to make order in the same order location
    checkTheAvailibilityToMakeOrder() {
      return new Promise((resolve) => {
        this.locationStatus = helpers.canMakeOrder(this.orderLocation);

        let message = this.$t("message.close_now_comeback_later");
        if (this.orderLocation.openingHours.suspended) {
          message = this.$t("message.location_temporary_paused_to", {paused_to : this.orderLocation.paused_to })
          helpers.showErrorMessageAlert(message);
          resolve(false);
        }
        switch (this.order.order_type) {
          case enumHelper.orderType.Delivery:
            if (this.locationStatus.openingHours.delivery) {
              resolve(true);
            } else if (this.locationStatus.can_accept_delivery) {
              message = this.$t("message.pre_order_confirmation" , {location_name : this.orderLocation.name})
              helpers
                .showMessageConfirmation(
                  message,
                  null,
                  null,
                  this.$t("button.continue"),
                  this.$t("button.cancel")
                )
                .then((response) => {
                  resolve(response);
                });
            } else {
              helpers.showErrorMessageAlert( this.$t("message.location_not_allowing_delivery"));
              resolve(false);
            }

            break;
          case enumHelper.orderType.Collection:
            if (this.locationStatus.openingHours.collection) {
              resolve(true);
            } else if (this.locationStatus.can_accept_collection) {
              message = this.$t("message.pre_order_confirmation" , {location_name : this.orderLocation.name})
              helpers
                .showMessageConfirmation(
                  message,
                  null,
                  null,
                  this.$t("button.continue"),
                  this.$t("button.cancel")
                )
                .then((response) => {
                  resolve(response);
                });
            } else {
              helpers.showErrorMessageAlert(this.$t('message.location_not_allowing_collection'));
              resolve(false);
            }
            break;
          case enumHelper.orderType.Table:
            if (
              this.locationStatus.openingHours.sitIn ||
              this.locationStatus.can_accept_tableOrdering
            ) {
              resolve(true);
            } else if (!this.locationStatus.can_accept_tableOrdering) {
              helpers.showErrorMessageAlert(this.$t('messahe.location_not_allowing_table'));
              resolve(false);
            }
            break;
        }
      });
    },

    //===== Step 03 : After all the order validation => add the itams to the cart
    continueReOrdering(fromModal = false) {
      //----- if the order type is delivery => request the location based on the order address
      this.setLocation(this.orderLocation);
      this.cart = cartManager.InitCart();
      this.cart.order = [];
      this.cart.orderType = this.order.order_type;
      this.cart.comment = "";
      if (this.cart.orderType == enumHelper.orderType.Delivery)
        this.cart.postCode = this.order.address.postcode;

      //---- prepare the object cart and save-it
      this.orderCart.data[0].cart.forEach((cartItem) => {
        let orderItem = this.order.orderItems.find((x) => x.id == cartItem.id);
        if (orderItem) {
          if (orderItem.comment)
            orderItem.menuItem.comment = orderItem.comment.body;

          orderItem.menuItem.quantity = orderItem.quantity;

          orderItem.menuItem.options.forEach((option) => {
            let cartOptions = cartItem.options.filter(
              (y) => y.menu_option_id == option.id
            );

            if (cartOptions && cartOptions.length) {
              if (option.type == "RADIO" || option.type == "SELECT") {
                option.selected = cartOptions[0].value.menu_option_value_id; // only one option will be selected
              } else if (option.type == "CHECKBOX") {
                option.selected = cartOptions.map(
                  (y) => y.value.menu_option_value_id
                );
              }
            }
          });
          this.cart.order.push(orderItem.menuItem);
        }
      });

      //---- set the delivery_fees
      this.setCartDeliveryFee().then((result) => {
        if (!result) cartManager.setCart(this.cart, true, false);

        //---- if is coming from confirmation Modal : need to close-it
        if (fromModal) {
          this.$refs.reOrderConfirmation.closeModal();
          this.continueReOrderEventListner();
        }
        this.closeModal();
        this.$nextTick(() => {
          router.push("/menu");
        });
      });
    },

    checkTheOrderBeforeOrdering(ordreDetails) {
      return new Promise((resolve) => {
        if (ordreDetails.data.length) {
          this.ItemsNotAvailable = [];
          this.ItemsNotAvailableByType = [];
          this.ItemsWithDiffPrice = [];
          this.ItemsNotAvailableForToday = [];
          this.ItemsNotAvailableByTime = [];

          this.order.orderItems.forEach((orderItem) => {
            let optionsValuesResult = this.checkOptionsAndValuesAvailibility(
              ordreDetails.data[0].cart,
              orderItem
            );
            //--- check if the orderItem still vailable
            if (
              this.checkOrderItemAvailibility(
                ordreDetails.data[0].not_available,
                orderItem
              )
            ) {
              this.ItemsNotAvailable.push(orderItem);
            } else if (
              this.checkOrderItemAvailibility(
                ordreDetails.data[0].not_available_today,
                orderItem
              )
            ) {
              this.ItemsNotAvailableForToday.push(orderItem);
            } else if (
              this.checkOrderItemAvailibility(
                ordreDetails.data[0].not_available_time,
                orderItem
              )
            ) {
              this.ItemsNotAvailableByTime.push(orderItem);
            } else if (
              //--- check if the orderItem still available by orderType (Delivery, Collectionn SitIn)
              helpers.checkIfItemAvailbleByOrderType(
                this.order.order_type,
                orderItem
              )
            ) {
              this.ItemsNotAvailableByType.push(orderItem);
            } else if (
              optionsValuesResult.options.length ||
              optionsValuesResult.values.length
            ) {
              this.ItemOptionsValuesAvailibility.push({
                orderItem: orderItem,
                options: optionsValuesResult.options,
                values: optionsValuesResult.values,
              });
            } else if (
              //--- check if the orderItem price changed
              helpers.getReOrderItemTotal(orderItem) !=
              helpers.getOriginItemTotal(orderItem, this.order.order_type)
            ) {
              this.ItemsWithDiffPrice.push(orderItem);
            }
          });
          var showPopUp =
            !!this.ItemsNotAvailable.length ||
            !!this.ItemsWithDiffPrice.length ||
            !!this.ItemsNotAvailableByType.length ||
            !!this.ItemOptionsValuesAvailibility.length ||
            !!this.ItemsNotAvailableForToday.length ||
            !!this.ItemsNotAvailableByTime.length;

          resolve(showPopUp);
        }
        resolve(false);
      });
    },

    checkOrderItemAvailibility(arrItem, orderItem) {
      return arrItem.find((x) => {
        return x.id == orderItem.menuItem.menu_item_id
      });
    },

    checkMenuItemAvailibility(_orderCart, orderItem) {
      return _orderCart.find((cartItem) => {
        return (
          orderItem.id == cartItem.id &&
          orderItem.menu_item_id == cartItem.location_menu_item_id
        );
      });
    },

    //===== check if the menuItem have any changes in the options or values
    checkOptionsAndValuesAvailibility(cart, orderItem) {
      let optionsNotExist = [];
      let valuesNotExist = [];

      if (!orderItem.options.length)
        return { options: optionsNotExist, values: valuesNotExist };

      let cartItem = cart.find((item) => item.id == orderItem.id);

      if (!cartItem)
        return { options: optionsNotExist, values: valuesNotExist };

      orderItem.options.forEach((option) => {
        let optExist = cartItem.options.filter(
          (x) => x.menu_option_id == option.menu_option_id
        );
        if (!optExist.length) optionsNotExist.push(option);
        else {
          let valExist = optExist.find(
            (y) =>
              y.value.menu_option_value_id ==
              option.values[0].menu_option_value_id
          );
          if (!valExist) valuesNotExist.push(option);
        }
      });
      return { options: optionsNotExist, values: valuesNotExist };
    },

    continueReOrderEventListner() {
      this.$root.$off("CONTINUE_REORDER");
      this.$root.$on("CONTINUE_REORDER", (fromModal) => {
        this.continueReOrdering(fromModal);
      });
    },

    setLocation(location) {
      this.$store.dispatch("storeSelectedLocation", location);
    },

    setCartDeliveryFee() {
      return new Promise((resolve) => {
        if (this.cart.orderType != enumHelper.orderType.Delivery)
          resolve(false);

        if (
          this.cart.orderType == enumHelper.orderType.Delivery &&
          this.selectedLocation.availabe_delivery_postcode
        ) {
          if (this.cart.order.length)
            // call this method if the cart total is > to 0
            this.cart.delivery_fee = helpers.getDeliveryFee(
              this.selectedLocation.delivery_condition,
              this.cart.total
            );
          else {
            this.cart.delivery_fee = helpers.getDefaultDeliveryFee(
              this.selectedLocation.delivery_condition
            );
          }
          cartManager.setCart(this.cart, true, false);
          resolve(true);
        }
        resolve(false);
      });
    },
  },
  created: function() {
    this.continueReOrderEventListner();
  },
};
</script>
